import React, { useState, useEffect } from 'react';

const Footer = () => {
  // 読み込んだHTMLを保存するためのstateを定義
  const [footerHtml, setFooterHtml] = useState('');

  // コンポーネントが最初に表示された時に一度だけ実行する処理
  useEffect(() => {
    // 外部のHTMLファイルをfetchで取得
    fetch('/footer.html') // publicフォルダなどに置いたHTMLへのパス
      .then(response => response.text())
      .then(data => {
        // 取得したHTMLをstateに保存
        setFooterHtml(data);
      })
      .catch(error => console.error('Error fetching footer HTML:', error));
  }, []); // 第2引数の配列を空にすると、初回の一度だけ実行される

  // stateに保存されたHTMLを dangerouslySetInnerHTML を使って描画
  return <div dangerouslySetInnerHTML={{ __html: footerHtml }} />;
};

export default Footer;